import Home from '@/views/Home';

export default {
    path: '/',
    redirect: {
        /**
         * In lieu of a "real" home page, redirect users over to the Mail Search page.
         * If the user isn't authorized to go to the Mail Search page,
         * the router will kick in and take them to the next authorized route in their nav list.
         * See the router's "goToNextIfAuthorizedAndExists" for implementation details.
         */
        path: '/mail/search',
    },
    name: 'Home',
    meta: {
        title: 'Home',
        documentTitle: 'Home',
        requiresAuth: true,
        mdiIcon: 'email',
        shouldPersistBetweenLogins: false,
    },
    component: Home,
};
